import React, { Fragment } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import TabularEntity from "./TabularEntity";
import EditEntityModal from "../EditEntityModal";
import GQLUtil from "../../../global/utils/gqlHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";
import ViewEntityTabularUIResolver from "./UISchemas/resolver";
import "./ViewEntitiy.scss";
import { ReactTable } from "../../SimpleForm/ReactTable";

class ViewEntityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      formData: null,
      loading: true,
    };
  }

  async componentDidMount() {
    const { id, formName, groupId } = this.props;
    let query = ViewEntityQueryResolver(formName, id, groupId);
    const data = await GQLUtil.genericGQLQuery(query);
    this.loadedData();

    this.setState({
      formData: data.data,
    });
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  loadedData = () => {
    this.setState({ loading: false });
  };

  render() {
    const { menuItemStyle, formName, id, isSubaccount } = this.props;

    const modalStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    const closeButton = {
      position: "absolute",
      right: "20px",
      top: "20px",
      background: "none",
      border: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
    };

    const bottomViewActions = {
      display: "flex",
      marginTop: "40px",
      justifyContent: "space-between",
      alignItems: "baseline",
    };

    const bottomViewButton = {
      width: "115px",
    };

    let tabularUI = ViewEntityTabularUIResolver(formName, this.state.formData);
    return (
      <Fragment>
        <button
          style={menuItemStyle}
          className="menu-item menu-item-button dropdown-label-View"
          type="button" // This removes default submit
          onClick={this.openModal}
        >
          <span>View</span>
        </button>
        <Modal
          style={modalStyles}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          overlayClassName="Overlay"
        >
          <button style={closeButton} onClick={this.closeModal} type="button">
            <MdClose style={closeButtonIcon} />
          </button>
          {formName === "foreign-worker-group" ? (
            <div className="table-view">
              <ReactTable
                columns={tabularUI.columns}
                data={tabularUI.data || []}
                tableTheme="genericTheme"
                noDataComponent={tabularUI.noData}
                loading={this.state.loading}
                showPagination={
                  tabularUI.data ? tabularUI.data.length > 5 : false
                }
                defaultSorted={[
                  {
                    id: tabularUI.id,
                    asc: true,
                  },
                ]}
              ></ReactTable>
            </div>
          ) : (
            <TabularEntity ui={tabularUI}>
              <div style={bottomViewActions}>
                {!isSubaccount ? (
                  <EditEntityModal
                    id={id}
                    menuItemStyle={menuItemStyle}
                    formName={formName}
                  />
                ) : (
                  <span />
                )}
                <button
                  className="usa-button usa-button--outline"
                  style={bottomViewButton}
                  onClick={this.closeModal}
                >
                  Close
                </button>
              </div>
            </TabularEntity>
          )}
        </Modal>
      </Fragment>
    );
  }
}

export default ViewEntityModal;
